// Import
import React from 'react';
import { get, set } from './Storage';
import axios from 'axios';
import * as Colors from 'material-ui/styles/colors';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

//import CircularProgress from 'material-ui/CircularProgress';
import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme';
import Tabs from "./Tabs";
import Drawer from 'material-ui/Drawer';
import { IsNotAuthError, ClassName, Base64 } from "mgToolsKit";
import KeepAlive from './KeepAlive';
import UPage from './UPage';
import PropTypes from 'prop-types';
import DepositToolsListTable from './Table/DepositToolsList';
import WithdrawalToolsListTable from './Table/WithdrawalToolsList';
import TicketsListTable from './Table/TicketList/TicketList';
import MemobetListTable from './Table/MemobetList';
import {setSetting} from './UserSettings';
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import { Message, Loader, Theme, GetTheme, SwitchTheme } from 'mgUiKit';
import WidgetMission from './Widget/WidgetMission';
// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'AppComponent';

var baseTheme;
var muiTheme;

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            defaultTab: "profile",
            countNews: 0,
            countCoupon: 0,
            alertProfile: false,
            toolbarData: {
                name: "",
                userTypeDescription: ""
            },
            sessionInfo: null,
            toolbarMode: AppSettings['userSettings'].toolbarMode,
            error: false,
            loading: true,
            IsNotAuthError: false,
            // Page
            pageTitle: "",
            pageBody: "",
            pageStatus: false, 
            toolbarBalance:"",
            toolbarBonusBalance:"",
            themeVersion: AppSettings.globalswitchthemeenabled  ? 
                 (localStorage.getItem("mg-theme") || AppSettings.theme.version) : 
            AppSettings.theme.version,
            // themeVersion: AppSettings.theme.version,
            run: false,
            dataBalance: null,
            steps: [
                {
                    placement: "center",
                    title: AppSettings['label'].KomodoLabelTourTitle,
                    target:'#user-box-profilo',
                    content: <div dangerouslySetInnerHTML={{__html: AppSettings['label'].KomodoLabelTourStep1}}></div>,
                    disableBeacon: true, //disabilita il beacon e fa partire al run lo step 1
                    offset: 1
                },
                {
                    placement: AppSettings.device == "mobile" ? "bottom" : "left",
                    target: AppSettings['userSettings'].toolbarMode == "compact" ? '#user-box-profilo' : '.komodo-profile',
                    content: <div dangerouslySetInnerHTML={{__html: AppSettings['label'].KomodoLabelTourStep2}}></div>,
                    disableBeacon: true,
                    spotlightPadding: 10,
                    offset: 2
                }
              ],
              stepIndex: 0,
              baseInfoData: null,
              countMission: 0,
              countPromoCoupon: 0,
              countFreebet: 0,
              countFunbonus: 0,
              fido: '',
              balance:null
        }

        this.switchToolbar = this.switchToolbar.bind(this);
        this.handleTab = this.handleTab.bind(this);
        this.openLinkPopup = this.openLinkPopup.bind(this);
        this.loadingNotificationInfo = this.loadingNotificationInfo.bind(this);
        this.updateToolbarCount = this.updateToolbarCount.bind(this);
        this.getExternalToolbarBalance = this.getExternalToolbarBalance.bind(this);
        this.setExternalToolbarBalance = this.setExternalToolbarBalance.bind(this);

        // Handle UPage
        this.handleSetPage = this.handleSetPage.bind(this);
        this.handlerClosePage = this.handlerClosePage.bind(this);
        this.openTicketsList = this.openTicketsList.bind(this);
        this.openMemobetList = this.openMemobetList.bind(this);
        this.switchTheme = this.switchTheme.bind(this);
        this.openDepositToolList = this.openDepositToolList.bind(this);
        this.openWithdrawalToolList = this.openWithdrawalToolList.bind(this);
        this.theme = "";
        this.openMissionsToolList = this.openMissionsToolList.bind(this);

        // update alertProfile value
        this.setBalanceData = this.setBalanceData.bind(this);
        this.checkIsAlertProfileActive = this.checkIsAlertProfileActive.bind(this)
        // blockApi, check date and time
        //this.checkBlockApi = this.checkBlockApi.bind(this);
        // this.isTimeInRange = this.isTimeInRange.bind(this);
        // this.convertTimeToMinutes = this.convertTimeToMinutes.bind(this);
    }

    componentDidMount() {
        if (AppSettings.device == "mobile") {
            window.addEventListener("scroll", this.stickyToolbar.bind(this));
        }

        this.setState({
        run: this.showJoyride()
        });

        AppSettings.globalswitchthemeenabled && document.addEventListener('themeChanged', function(e) {
            this.switchTheme(e.detail.theme);
        }.bind(this));
    
       
    }
    
    componentWillMount() {
        if(AppSettings.isauthenticated){
            if(AppSettings.device == "mobile"){
                this.loadingNotificationInfo();
            }
            else{
                this.refreshBalance(AppSettings['balanceOpened']);    
            }
        }        
    }
    componentWillUnmount() {
        if (AppSettings.device == "mobile") {
            window.removeEventListener("scroll", this.stickyToolbar.bind(this));
        }
    }

    showJoyride(){
        return localStorage.getItem(AppSettings["env"].localStorageKomodoTour) != null;
    }

    setJoyride(){
        localStorage.setItem(AppSettings["env"].localStorageKomodoTour, new Date().getTime());
    }

    checkIsAlertProfileActive = (newValue) => {
        this.setState({ alertProfile: newValue });
      };

    checkBlockApi(value) {
        let isBlocked = false;
        try{
            const timeBlocks = value.split('|');
            for (let block of timeBlocks){
                if(block !== ""){
                    const [blockDay, startTimeBlock, endTimeBlock] = block.split(',');
                    if(blockDay == null || startTimeBlock == null || endTimeBlock == null){
                        continue; 
                    }

                    let now = new Date();
                    let start = new Date();
                    const[hs, ms] = startTimeBlock.split(':');
                    start.setHours(hs);
                    start.setMinutes(ms);

                    let end = new Date();
                    const[he, me] = endTimeBlock.split(':');
                    end.setHours(he);
                    end.setMinutes(me);
                    
                    if((start instanceof Date && isNaN(start))|| (end instanceof Date && isNaN(end))){
                        continue;
                    }

                    if(now.getDay() === parseInt(blockDay) && now >= start && now <= end){
                        isBlocked = true;
                        break;
                    }
                }
            }
        }
        catch(e){
            console.log(e);
            isBlocked = false;
        }
        return isBlocked;
    }

    // isTimeInRange = (currentTime, startTime, endTime) => {
    //     const currentTimeInMinutes = this.convertTimeToMinutes(currentTime);
    //     const startTimeInMinutes = this.convertTimeToMinutes(startTime);
    //     const endTimeInMinutes = this.convertTimeToMinutes(endTime);

    //     return currentTimeInMinutes >= startTimeInMinutes && currentTimeInMinutes <= endTimeInMinutes;
    // };

    // convertTimeToMinutes = (timeString) => {
    //     const [hours, minutes] = timeString.split(':').map(Number);
    //     return hours * 60 + minutes;
    // }

    handleJoyrideCallback = (data) => {
        const { action, index, status, type } = data;
    
        if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
          // Update state to advance the tour
          this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
        }
        else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
          // Need to set ou rrunning state to false, so we can restart if we click start again.
          this.setState({ run: false });
          this.setJoyride();
        }
      };

    openLinkPopup(e,url){
        if(AppSettings.openlinkpopup 
            && typeof window._site != 'undefined' && typeof window._site.modal != 'undefined'
            && AppSettings.device != "mobile"){
            let data = {targetUrl:url.replace("http://", "https://"), title : "Il mio conto" };
            //data-modaltitle
            window._site.modal.open(data);
            e.preventDefault();
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();

            this.handleTab(false);
        }
        else{
            location.href = url;
        }
    }

    switchToThemeDark(){
        if(this.state.themeVersion != "dark"){
            this.setState({
                themeVersion: "dark"
            });
        }
    };

    switchToThemeLight(){
        if(this.state.themeVersion != "light"){
            this.setState({
                themeVersion: "light"
            });
        }
    };

    switchTheme(theme){
        this.setState({
            themeVersion: theme
        });
    }



    setTheme(themeVersion){
       this.theme = GetTheme();
        if (AppSettings.theme.primarycolor != "") {
            this.theme.primaryColor = AppSettings.theme.primarycolor;
        }

        // Versione scura
        if (themeVersion == 'dark') {
            baseTheme = darkBaseTheme;
            baseTheme.palette.canvasColor = Colors.grey900;
            baseTheme.palette.textColor = Colors.white;
            baseTheme.palette.accent2Color = Colors.grey100;
        }
        // Versione chiara
        else {
            baseTheme = lightBaseTheme;
            baseTheme.palette.canvasColor = Colors.grey300;
            baseTheme.palette.textColor = Colors.grey600;
        }

        baseTheme.palette.primary1Color = AppSettings.theme.primarycolor;
        baseTheme.palette.primary2Color = AppSettings.theme.secondarycolor;
        baseTheme.palette.accent1Color = AppSettings.theme.primarycolor;

        var styles = AppSettings["styles"];
        if(themeVersion == 'dark'){
            styles['mgCardStyle']['background'] = Colors.grey800;
            styles['Read']['background'] = Colors.grey900;
            styles['noRead']['background'] = Colors.grey800;
        }
        else{
            styles['mgCardStyle']['background'] = Colors.white;
            styles['Read']['background'] = Colors.grey100;
            styles['noRead']['background'] = Colors.grey300;
        }
        AppSettings['styles'] = styles;
        
        AppSettings['baseTheme'] = baseTheme;
        set(AppSettings);

        muiTheme = getMuiTheme(baseTheme);
    }

    stickyToolbar(){
        try{
            var header = document.getElementById(AppSettings.userbox);
            var sticky = header.offsetTop;
            if (window.pageYOffset > sticky) {
                header.classList.add("sticky");
            } 
            else {
                header.classList.remove("sticky");
            }
        }
        catch(e){

        }
    }

    isAuthenticated(){
        return AppSettings.isauthenticated;
    }
    
    setUserAuthenticated(){
        AppSettings.isauthenticated = true;
        set(AppSettings);

        this.loadingNotificationInfo();
        this.destroyLocalStorage();
    }

    setUserNotAuthenticated(){
        AppSettings.isauthenticated = false;
        set(AppSettings);

        this.loadingNotificationInfo();
        this.destroyLocalStorage();
    }

    refreshUserBox(){
        this.setState({
            loading:true
        });
        setTimeout(function(){
            this.setState({
                loading:false
            });
        }.bind(this),1000);

    }

    switchToolbar(mode) {
        AppSettings['userSettings']['toolbarMode'] = mode
        set(AppSettings);
        
        setSetting(AppSettings['userSettings']);
        this.setState({
            toolbarMode: mode
        });
    }

    refreshBalance(show) {
        return new Promise((resolve, reject) => {
            let that = this;
            let pvrSwitchBalance = document.getElementById("switch-balance");
            that.setBalanceData(null);
            if (show || show == undefined) {
                var url = AppSettings['env'].urlUserBoxGetBalance;
                axios.get(url).then(({ data, status, statusText }) => {
                    var balance = '';
                    var fido = '';
                    var bonusBalance = '0'

                    if (data.errors.length == 0) {
                        that.setBalanceData(data);
                        this.setExternalToolbarBalance(data);
                        if (data.bonusBalance !== null) {
                            bonusBalance = data.bonusBalance;
                        }
                        if (data.fido !== 0) {
                            fido = data.fidoStr;
                        }

                        balance = data.balance;
                        that.setStatusBalance(true);
                        if (pvrSwitchBalance) {
                            pvrSwitchBalance.classList.add("fa-mg-eye-slash-1");
                            pvrSwitchBalance.classList.remove("fa-mg-eye-1");
                        }
                        document.querySelectorAll("[data-ub-balance]").forEach(function (el) { el.innerHTML = balance });
                        document.querySelectorAll("[data-ub-min-balance]").forEach(function (el) { el.innerHTML = fido });
                        document.querySelectorAll("[data-ub-min-bonus]").forEach(function (el) { el.innerHTML = bonusBalance });
                        that.loadingNotificationInfo();
                    }
                    resolve();
                })
                    .catch(function (error) {
                        reject(error);
                    });
            }
            else {
                that.setStatusBalance(false);
                if (pvrSwitchBalance) {
                    pvrSwitchBalance.classList.add("fa-mg-eye-1");
                    pvrSwitchBalance.classList.remove("fa-mg-eye-slash-1");
                }
                document.querySelectorAll("[data-ub-balance]").forEach(function (el) { el.innerHTML = "---" });
                document.querySelectorAll("[data-ub-min-balance]").forEach(function (el) { el.innerHTML = "---" });
                document.querySelectorAll("[data-ub-min-bonus]").forEach(function (el) { el.innerHTML = '---' });
                that.loadingNotificationInfo();
                resolve();
            }
        });
    }

    getBalanceData(){
        return this.state.balance;
    }

   setBalanceData(data){
        this.setState({balance: data});
    }
    
    setStatusBalance(status){
        AppSettings['balanceOpened'] = status
        set(AppSettings);
        if (typeof (Storage) !== "undefined") {
            localStorage.setItem(AppSettings["env"].localStorageToggleBalance, status);
        }

        // Pvr panel
        let dashboardPvr = document.getElementById("mg-pvr-balance");
        let elmSwt = document.getElementById("switch-balance");
        if(dashboardPvr != null && elmSwt != null) {
            elmSwt.checked = status;
            if(status){
                dashboardPvr.classList.add('show');
            }
            else{
                dashboardPvr.classList.remove('show');

            }
        }
    }

    getChildContext() {
        return {
            countNews: this.state.countNews,
            countCoupon: this.state.countCoupon,
            getExternalToolbarBalance: this.getExternalToolbarBalance,
            setExternalToolbarBalance: this.setExternalToolbarBalance,
            updateToolbarCount: this.updateToolbarCount,
            handleTab: this.handleTab,
            refreshBalance: this.refreshBalance,
            userboxOpened: this.state.open,
            handleSetPage: this.handleSetPage,
            handlePlayCasinoGame: this.handlePlayCasinoGame,
            checkIsAlertProfileActive: this.checkIsAlertProfileActive,
            openLinkPopup: this.openLinkPopup,
            openTicketsList: this.openTicketsList,
            openMemobetList: this.openMemobetList,
            switchTheme: this.switchTheme,
            openDepositToolList: this.openDepositToolList,
            openWithdrawalToolList: this.openWithdrawalToolList,
            countMission: this.state.countMission,
            openMissionsToolList: this.openMissionsToolList,
            setStatusBalance: this.setStatusBalance,
            setBalanceData: this.setBalanceData
        };
    }

    destroyLocalStorage() {
        if (typeof (Storage) !== "undefined") {
            sessionStorage.removeItem(AppSettings['env'].localStorageName.name);
        }
    }

    updateToolbarCount(type, count) {
        //this.destroyLocalStorage();
        if (type == 'news') {
            this.setState({
                countNews: count
            });
        }

        if (type == 'coupon') {
            this.setState({
                countCoupon: count
            });
        }
    }

    setData(data) {
        AppSettings["urls"] = {};
        if (data.urls.length > 0) {
            for (var index in data.urls) {
                var url = data.urls[index];
                AppSettings["urls"][url.key] = url;
            }
        }
        AppSettings["perms"] = [];
        AppSettings["lastLogin"] = data.lastLogin;
        AppSettings["urlLogout"] = data.urlLogout;
        AppSettings["username"] = data.username;
        AppSettings["firstName"] = data.firstName;
        AppSettings["lastName"] = data.lastName;
        AppSettings["isPartner"] = data.userType == "partner";
        AppSettings["isExternalPlayer"] = data.userType == "externalPlayer";
        AppSettings["sessionExpire"] = data.sessionInfo.sessionExpire;
        AppSettings["homeRealm"] = data.homeRealm;
        AppSettings["komodo"] = data.k;
        try {
            if (data.perms.length > 0) {
                for (var perm of data.perms) {
                    AppSettings["perms"][perm.Key] = perm.Value;
                }
                if(!AppSettings.sportsbookenabled){
                    AppSettings["perms"].ticketList = false;
                    AppSettings["perms"].memobet = false;
                }
            }
        }
        catch (e) {

        }
        
        set(AppSettings);
        var toolbarData = {
            name: "Ciao " + data.firstName, // + " " + data.lastName,
            userTypeDescription: data.userTypeDescription,
            username: data.username,
        };
        
        this.setState({
            toolbarData: toolbarData,
            countNews: data.countNews,
            countCoupon: data.countCoupon,
            sessionInfo: data.sessionInfo,
            error: false,
            loading: false,
            IsNotAuthError: false,
            baseInfoData: data,
            countMission: data.countMission,
            countPromoCoupon: data.countPromoCoupon,
            countFreebet: data.countFreebet,
            countFunbonus: data.countFunbonus
        });

        let _that = this;
        //effettuo il controllo del redirect partner
        if (AppSettings['isPartner']) {
            setTimeout(() => { _that.checkPartnerDashboardRedirect()}, 1000);
        }
    }

    errorFunction(error) {
        this.setState({
            error: true,
            loading: false,
            IsNotAuthError: false
        });

    }

    getUserboxInfo(){
        return this.state.baseInfoData;
    }

    getCountCoupons() {
        if(AppSettings.isauthenticated == false){
            return;
        }
        var url = AppSettings['env'].urlUserBoxCountCoupons;
        axios.get(url)            
            .then(({ data, status, statusText }) => {
                let totalCoupon = 0;
                let countPromoCoupon = 0;
                let countFreebet = 0;
                let countFunbonus = 0;
                if (data.errors.length == 0) {
                    totalCoupon = data.count;
                    countPromoCoupon = data.countCoupon;
                    countFreebet = data.countFreebet;
                    countFunbonus = data.countFunbonus;
                }
                var data = sessionStorage.getItem(AppSettings['env'].localStorageName.name);
                if (data) {
                    try {
                        data = JSON.parse(Base64.decode(data));
                        data.baseInfo.countCoupon = totalCoupon;
                        data.baseInfo.countPromoCoupon = countPromoCoupon;
                        data.baseInfo.countFreebet = countFreebet;
                        data.baseInfo.countFunbonus = countFunbonus;
                        sessionStorage.setItem(
                            AppSettings['env'].localStorageName.name,
                            Base64.encode(JSON.stringify(data))
                        );
                    }
                    catch (e) {

                    }
                }

                this.setState({
                    countCoupon: totalCoupon,
                    countPromoCoupon: countPromoCoupon,
                    countFreebet: countFreebet,
                    countFunbonus: countFunbonus
                });   
            })
            .catch();
    }

    getCountMissions() {
        if(AppSettings.isauthenticated == false){
            return;
        }
        var url = AppSettings['env'].urlUserBoxCountMissions;
        axios.get(url)            
            .then(({ data, status, statusText }) => {

                let countMission = 0;
                if (data.errors.length == 0) {
                    countMission = data.count;
                }
                var data = sessionStorage.getItem(AppSettings['env'].localStorageName.name);
                if (data) {
                    try {
                        data = JSON.parse(Base64.decode(data));
                        data.baseInfo.countMission = countMission;
                        sessionStorage.setItem(
                            AppSettings['env'].localStorageName.name,
                            Base64.encode(JSON.stringify(data))
                        );
                    }
                    catch (e) {

                    }
                }

                this.setState({
                    countMission: countMission
                });   
            })
            .catch();
    }

    getCountNews() {
        if(AppSettings.isauthenticated == false){
            return;
        }
        var url = AppSettings['env'].urlUserBoxCountNews;
        axios.get(url)            
            .then(({ data, status, statusText }) => {
                let countNews = 0;
                if (data.errors.length == 0) {
                    countNews = data.count;
                }
                var data = sessionStorage.getItem(AppSettings['env'].localStorageName.name);
     
                const newsCountPVR = document.querySelector("[data-ub-news-count]");
                if(newsCountPVR){
                    newsCountPVR.setAttribute("data-ub-news-count", countNews);
                    if(countNews > 0) {
                    newsCountPVR.innerHTML= countNews;
                    newsCountPVR.classList.add("news-counter");
                    } else {
                        newsCountPVR.classList.remove("news-counter");
                    }
                }

                if (data) {
                    try {
                        data = JSON.parse(Base64.decode(data));
                        data.baseInfo.countNews = countNews;
                        sessionStorage.setItem(
                            AppSettings['env'].localStorageName.name,
                            Base64.encode(JSON.stringify(data))
                        );
                    }
                    catch (e) {

                    }
                }

                this.setState({
                    countNews: countNews
                });   
            })
            .catch();
    }
    
    getCount(){
        let totalPromo = this.state.countCoupon + this.state.countMission;
        return {
            totalPromo: totalPromo,
            freebet: this.state.countFreebet,
            funbonus: this.state.countFunbonus,
            coupon: this.state.countPromoCoupon,
            mission: this.state.countMission,
            news: this.state.countNews
        }

    }

    loadingNotificationInfo() {
        let self = this;
        if(AppSettings.isauthenticated == false){
            return;
        }
        // Se nello storage locale ho le info di base evito la chiamata AJAX
        if (typeof (Storage) !== "undefined") {
            var data = sessionStorage.getItem(AppSettings['env'].localStorageName.name);
            if (data) {
                try {
                    data = JSON.parse(Base64.decode(data));
                    if (data.username != AppSettings.username || Date.now() >= data.expire) {
                        this.destroyLocalStorage();
                    }
                    else {
                        this.setData(data.baseInfo);
                        return true;
                    }
                }
                catch (e) {

                }
            }
        }

        var url = AppSettings['env'].urlUserBoxBaseInfo;
        axios.get(url)
            .then(({ data, status, statusText }) => {

                if (data.errors.length == 0) {
                    if (typeof (Storage) !== "undefined") {
                        var expire = Date.now() + AppSettings['env'].localStorageName.lifeTime;
                        var storage = {
                            username: AppSettings.username,
                            expire: expire,
                            baseInfo: data
                        }
                        sessionStorage.setItem(
                            AppSettings['env'].localStorageName.name,
                            Base64.encode(JSON.stringify(storage))
                        );
                    }

                    this.setData(data);

                    let apiBlockingSchedule = data.stopApiCalendar;
                    let isBlocked = false;
                    
                    if(apiBlockingSchedule !== '') {
                        isBlocked = this.checkBlockApi(apiBlockingSchedule);
                    }

                    if(!isBlocked){
                        if (AppSettings['perms'].tabCoupon){
                            self.getCountCoupons();
                        }
                
                        if (AppSettings['perms'].tabMissions){
                            self.getCountMissions();
                        }

                        if (AppSettings['perms'].tabNews){
                            self.getCountNews();
                        }
                    } 

                } else {
                    this.setState({
                        error: true,
                        loading: false,
                        IsNotAuthError: IsNotAuthError(data.errors)
                    });
                }
            })

            .catch(this.errorFunction);
    }

    // Gestione apertura userbox
    handleTab(tab) {
        if (tab === false) {
            this.setState({
                open: false
            });

        }
        else {
            if (tab === true) {
                tab = "profile";
            }
            else if(tab == "empty"){
                tab = "";
            }
            this.setState({
                open: true,
                defaultTab: tab,
                pageTitle: "",
                pageBody: null,
                pageStatus: false
            });
        }
    }

    openDepositToolList(){
        // Se la userbox non è aperta apro la tab pannello per poi
        // mostrare l'elenco dei sistemi di ricarica
        if(!this.state.open){
            this.handleTab(true);
           
        }
        else{
            /*
            this.setState({
                open: false
            });*/
        }
        var body = <DepositToolsListTable />;
        this.handleSetPage("Ricarica conto gioco", body,true);
        
    }

    openTicketsList(){
        if(!this.state.open){
            this.handleTab(true);
           
        }
        var body = <TicketsListTable />;
        this.handleSetPage("Ultime 20 scommesse", body,true);
    }

    openMemobetList(){
        if(!this.state.open){
            this.handleTab(true);
           
        }
        var body = <MemobetListTable />;
        this.handleSetPage("Le tue Memobet", body,true);
    }
    
    openWithdrawalToolList(){
        // Se la userbox non è aperta apro la tab pannello per poi
        // mostrare l'elenco dei sistemi di ricarica
        if(!this.state.open){
            this.handleTab(true);
           
        }
        else{
            /*
            this.setState({
                open: false
            });*/
        }
        var body = <WithdrawalToolsListTable />;
        this.handleSetPage("Preleva dal conto gioco", body,true);
        
    }

    openMissionsToolList(){
        if(!this.state.open){
            this.handleTab(true);
           
        }
        var body = <WidgetMission countMission={this.state.countMission}/>;
        this.handleSetPage("Le tue missioni", body,true);
    }

    handleSetPage(title, body, status) {
        if (title == undefined) {
            title = "";
        }
        if (body == undefined) {
            body = "";
        }
        if (status == undefined) {
            status = false;
        }
        this.setState({
            pageTitle: title,
            pageStatus: status,
            pageBody: body
        });

    }

    handlerClosePage() {
        this.setState({
            pageTitle: "",
            pageStatus: false,
            pageBody: ""
        });
    }

    handlePlayCasinoGame(game) {
        var data = sessionStorage.getItem(AppSettings['env'].localStorageName.name);
        data = JSON.parse(Base64.decode(data));

        if (AppSettings.device == "mobile") {

            var gameUrl = "http://" + AppSettings["env"].casinoDomain + "/singlesignon.ashx?homeRealm=" + data.baseInfo.homeRealm + "&s=" + data.baseInfo.homeRealm + "&rUrl=" +
                encodeURIComponent("http://" + AppSettings["env"].casinoDomain + "/mobile/PlayGame.aspx?gameCode=" + game.GameCode + "&gameTitle=" + game.GameName + "&type=r#transferFunds");
                location.href = gameUrl;
            return false;
        }

        var width = 640;
        var height = 580;

        var gameUrl = "http://" + AppSettings["env"].casinoDomain + "/singlesignon.ashx?homeRealm=" + data.baseInfo.homeRealm + "&s=" + data.baseInfo.homeRealm + "&rUrl=http://" + AppSettings["env"].casinoDomain + "/GameViewer?gameId=" + game.GameCode;

        var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
        var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

        var w = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var h = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        var left = ((w / 2) - (width / 2)) + dualScreenLeft;
        var top = ((h / 2) - (height / 2)) + dualScreenTop;

        var features = "width=" + width + "px, height=" + height + "px, resizable=no, scrollbars=1, toolbar=no, location=no, status=0, menubar=no" + ', top=' + top + ', left=' + left;

        window.open(gameUrl, game.GameCode, features);
        return false;
    }

    getExternalToolbarBalance(){
        return this.state.dataBalance;
    }

    setExternalToolbarBalance(dataBalance){
        this.setState({
            dataBalance: dataBalance
        });
    }

    checkPartnerDashboardRedirect(){
        if (AppSettings['isPartner'] && AppSettings.partner.disabledashboardredirect == 'false' ) {
            try{
                //se non c'è l'istanza pvr dashboard faccio redirect
                if(typeof _dashboardPVRInstance == 'undefined' && AppSettings['perms'].dashboardpvr){
                    let redirect = false;
                    //costruisco il valore del localstorage con un oggetto complesso
                    //nome dashboard-partner-redirect
                    //{["username":"partner", "lastLogin":"22-10-2022-12-00"]}

                    //se la last login è diversa, elimino tutti i riferimenti a partner e inserisco la nuova chiave
                    let localStoragePVRName = "dashboard-partner-redirect";
                    let partnerLastLogin = AppSettings["lastLogin"].replaceAll(' ','-').replaceAll('/','-').replaceAll(':','-');
                    let partnerUsername = AppSettings["username"];
                    let element = {"username":partnerUsername, "lastLogin":partnerLastLogin}

                    let _dashboardPartnerRedirect = localStorage.getItem(localStoragePVRName);

                    if(_dashboardPartnerRedirect != null){
                        let localStorageValue = JSON.parse(_dashboardPartnerRedirect);

                        const storedValueForUsername = localStorageValue.filter((e) => e.username == partnerUsername);
                        if(storedValueForUsername.length == 0){
                            localStorageValue.push(element);
                            localStorage.setItem(localStoragePVRName,JSON.stringify(localStorageValue));
                            redirect = true;
                        }
                        else{
                            //esiste la entry per il partner e devo verificare la login
                            if(storedValueForUsername[0].lastLogin != partnerLastLogin){
                                //login diverse, allora aggiorno e rimetto nel local storage
                                storedValueForUsername[0].lastLogin = partnerLastLogin;

                                localStorage.setItem(localStoragePVRName,JSON.stringify(localStorageValue));

                                redirect = true;
                            }
                        }

                        
                    }
                    else{
                        localStorage.setItem(localStoragePVRName,JSON.stringify([element]));
                        redirect = true;
                    }


                    if(redirect){
                        location.href = "/pvr-panel";
                        //console.log("redirect");
                    }
                }
            }
            catch(err){}
        }
        
    }

    render() {
        

        if(AppSettings.isauthenticated == false){

            return (
                <>
                    {AppSettings.theme.switchthemeversionenabled ? 
                        <SwitchTheme callBack={this.switchTheme.bind(this)}  mode="listner" />
                    : null}
                </>
            );
        }
        this.setTheme(this.state.themeVersion) 

        if (this.state.loading) {
            return (
                <Theme theme={this.theme}>
                    <MuiThemeProvider muiTheme={muiTheme}>
                        <Loader type="circular" />
                    </MuiThemeProvider>
                </Theme>
            );
        }

        var MainApp;
        //tour
        const { run, stepIndex, steps} = this.state;

        if (!this.state.error) {
            var ToolbarObj;
            var toolbarAttributes = {

            };
            if( AppSettings.forcetoolbartype != ""){
                ToolbarObj = require("./" + AppSettings.forcetoolbartype).default;
                let rootContainer = document.getElementById(AppSettings.userbox);
                if(rootContainer != null){
                    rootContainer.classList.add("ub-" + AppSettings.forcetoolbartype.toLowerCase());
                }
            }
            else{
                if (this.state.toolbarMode == "full") {
                    ToolbarObj = require("./Toolbar").default;
                } else {
                    ToolbarObj = require("./ToolbarCompact").default;
                }
            }

            let toolbarRender = (
                <ToolbarObj 
                    balance={this.state.toolbarBalance} 
                    bonusBalance={this.state.toolbarBonusBalance} 
                    key="toolbarRender"
                    countCoupon={this.state.countCoupon}
                    countNews={this.state.countNews} 
                    data={this.state.toolbarData}
                    handleTab={this.handleTab} 
                    alertProfile={this.state.alertProfile}
                    switchToolbar={this.switchToolbar} 
                    countMission={this.state.countMission}/>
            )

            var internalDrawerRender = new Array();

            if (this.state.open) {
                var page = <UPage onCloseAction={this.handlerClosePage} key="pageContainer" title={this.state.pageTitle} opened={this.state.pageStatus}>{this.state.pageBody}</UPage>;
                internalDrawerRender.push(page);
                internalDrawerRender.push(
                    <Tabs 
                        key="tabsContainer" 
                        toolbarData={this.state.toolbarData} 
                        defaultTab={this.state.defaultTab} 
                        alertProfile={this.state.alertProfile}
                    />);
            }
            var drawerRender = <Drawer
                key="dwawerRender"
                openSecondary={true}
                docked={false}
                width={310}
                disableSwipeToOpen={true}
                className="mg-wrap-tabs-container"
                containerClassName="mg-drawer"
                open={this.state.open}
                onRequestChange={this.handleTab}>
                {internalDrawerRender}
            </Drawer>;
            MainApp = [toolbarRender, drawerRender];
        }
        else {
            if (this.state.IsNotAuthError) {
                MainApp = <Message autoHide={true} type="info"> La tua sessione è scaduta</Message>;
            }
            else {
                MainApp = <Message />;
            }
        }

        var keepAlive = "";
        /*if (AppSettings.enablekeepalive) {
            keepAlive = <KeepAlive checkSession={true} sessionInfo={this.state.sessionInfo} />;
        }*/
        var _className = new Array();
        var _that = this;
        _className.push(this.state.themeVersion);
        if (AppSettings['isPartner'] || !AppSettings['perms'].tabCoupon) {
            _className.push("mg-userbox-partner");
        }
        else{
            _className.push("mg-userbox-player");
        }

        let bodyElement = document.getElementsByTagName("body");

        if(this.state.open){
            _className.push("ub-drawer-open");
            if(bodyElement.length > 0){
                bodyElement[0].classList.add("ub-active");
            }
            
        }
        else{
            if(bodyElement.length > 0){
                bodyElement[0].classList.remove("ub-active");
            }
        }

        var runTour = AppSettings['komodo'] != undefined && AppSettings['komodo'].url != location.pathname && !AppSettings["isPartner"] && AppSettings["perms"].komodo && !this.state.open;

        return (
            <Theme theme={this.theme}>
                <Joyride id="primary-tour" showSkipButton={false}
                    styles={{
                        options: {
                           // modal arrow and background color
                           arrowColor: AppSettings['baseTheme'].palette.primary1Color,
                           backgroundColor: this.state.themeVersion == "dark" ? AppSettings['baseTheme'].palette.canvasColor : Colors.white,
                           // page overlay color
                           //overlayColor: "rgba(79, 26, 0, 0.4)",
                           //button color
                           primaryColor: AppSettings['baseTheme'].palette.primary1Color,
                           //text color
                           textColor: AppSettings['baseTheme'].palette.textColor,
                           //width of modal
                           //width: 500,
                           //zindex of modal
                           zIndex: 101
                       }
                    }}
                    run={run && runTour} stepIndex={stepIndex} callback={this.handleJoyrideCallback} continuous={true} steps={steps} 
                    locale ={{back: 'Indietro', close: 'Chiudi', last: 'Ho capito!', next: 'Avanti', open: 'Apri in popup', skip: 'Salta' }}/>
                <MuiThemeProvider muiTheme={muiTheme}>
                    <>
                    {AppSettings.theme.switchthemeversionenabled ? 
                        <SwitchTheme callBack={this.switchTheme.bind(this)}  mode="listner" />
                    : null}
                        {keepAlive}
                        <div className={ClassName(_className)}>
                            {MainApp}
                        </div>
                    </>
                </MuiThemeProvider>
            </Theme>
        )
    }
}
App.displayName = componentName;

// PropTypes validation
App.propTypes = {};

// default props
App.defaultProps = {};

App.childContextTypes = {
    countNews: PropTypes.number,
    countCoupon: PropTypes.number,
    getExternalToolbarBalance: PropTypes.func,
    setExternalToolbarBalance: PropTypes.func,
    updateToolbarCount: PropTypes.func,
    handleTab: PropTypes.func,
    refreshBalance: PropTypes.func,
    userboxOpened: PropTypes.bool,
    handleSetPage: PropTypes.func,
    handlePlayCasinoGame: PropTypes.func,
    checkIsAlertProfileActive: PropTypes.func,
    openLinkPopup: PropTypes.func,
    openTicketsList: PropTypes.func,
    openDepositToolList: PropTypes.func,
    openWithdrawalToolList: PropTypes.func,
    openMemobetList: PropTypes.func,
    switchTheme: PropTypes.func,
    countMission: PropTypes.number,
    openMissionsToolList:PropTypes.func,
    setStatusBalance: PropTypes.func,
    setBalanceData: PropTypes.func
}

export default  App;